export default "__VITE_ASSET__CndagtvV__"